import { useContext, useEffect } from "react";

import { Alert, AlertTitle, Snackbar, Stack } from "@mui/material";
import ShowErrorToastContext from "@src/context/showErrorToast/showErrorToastContext";

const ErrorToast = () => {
  const [{ showErrorToastState, showErrorToastSetState }] = useContext(
    ShowErrorToastContext
  );

  const handleClose = () => {
    showErrorToastSetState({
      ...showErrorToastState,
      open: false,
      errorMessage: "",
      errorTitle: "",
    });
  };

  useEffect(() => {
    return () =>
      showErrorToastSetState({
        errorMessage: "",
        errorTitle: "",
        open: false,
      });
  }, []);

  return (
    <div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={showErrorToastState?.open}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            <AlertTitle>{showErrorToastState?.errorTitle}</AlertTitle>
            {showErrorToastState?.errorMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
};
export default ErrorToast;
